import { PriceListFormTabs } from "./constants";
import React from "react";
import { ResourceEnum } from "src/constants/constants.ts";
import type { ModuleOptions } from "src/system/module.types.ts";
import type { PriceListResource } from "@exonn/js-sdk";
import { createModuleRoutePaths } from "src/system/createModuleRoutePaths.ts";

const routePaths = createModuleRoutePaths({
  resource: ResourceEnum.PriceList,
});

const editRouteObject = {
  path: routePaths.edit.root,
  lazy: () => import("./routes/edit/edit.layout.tsx"),
  children: [
    {
      index: true,
      lazy: () => import("./routes/edit/tabs/general/edit.route.tsx"),
    },
    {
      path: routePaths.edit.tab(PriceListFormTabs.Exceptions).root,
      lazy: () => import("./routes/edit/tabs/exceptions/exceptions.route.tsx"),
      children: [
        {
          index: true,
          lazy: () =>
            import(
              "./routes/edit/tabs/exceptions/tabs/list/list.exceptions.tsx"
            ),
        },
        {
          path: routePaths.edit
            .tab(PriceListFormTabs.Exceptions)
            .tab(":price_list_item_id").root,
          lazy: () =>
            import(
              "./routes/edit/tabs/exceptions/tabs/edit/edit.exception.route.tsx"
            ),
        },
      ],
    },
  ],
};

export const module: ModuleOptions<PriceListResource> = {
  resource: ResourceEnum.PriceList,

  bigIcon: <i className="icon-20-pricelist" />,
  smallIcon: <i className="icon-15-price_lists" />,

  edit: {
    routeObject: editRouteObject,
  },

  formTabs: {
    general: {
      title: (t) => t("tabs.edit.tabs.general.title"),
    },
    exceptions: {
      title: (t) => t("tabs.edit.tabs.exceptions.title"),
    },
  },
};
